<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :hide-default-footer="true"
          :headers="headers"
          :items="cartItemList"
          :items-per-page="10"
          class="elevation-1"
        >
          <template v-slot:headers.subtotal="{ header }">
            {{header.value}}
          </template>

          <template v-slot:item.subtotal="{ item }">
            <span v-if="item.subject == 'Camp'">
              {{item.pricePerWeek * item.weeks.length | currency}}
            </span>
            <span v-else>
              {{item.pricePerCourse | currency}}
            </span>
          </template>

          <template v-slot:item.name="{ item }">
            <strong>
             <router-link :to="`/course/${item.id}`"> {{item.name}} </router-link>
            </strong>
          </template>

          <template v-slot:item.price="{ item }">
            <span v-if="item.subject == 'Camp'">
              {{item.pricePerWeek | currency}}/week
            </span>
            <span v-else>
              {{item.pricePerSession | currency}}/session
            </span>
          </template>

          <template v-slot:item.quantity="{ item }">
            {{item.quantity}}
            <span v-if="item.subject == 'Camp'">
              ({{item.weeks.length}} weeks)
            </span>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon @click="removeItem(item)">mdi-delete</v-icon>
          </template>
        </v-data-table>

        <div class="ma-4">
          <v-row>
            <v-col >
              <strong>Total: {{ cartValue | currency }}</strong>
            </v-col>
          </v-row>
          <v-row>
            <v-col style="text-align: right;">
              <v-btn to="/camp" class="ma-4">
                <v-icon>mdi-shop</v-icon> Continue Shopping
              </v-btn>
              <v-btn class="customPayButton ma-4" :to="{path: '/checkout'}">
                <v-icon>mdi-checkout</v-icon> Checkout
              </v-btn>
            </v-col>
          </v-row>
        </div>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data: () => ({
    headers: [
      { text: "Course", value: "name", align: "start", sortable: false },
      { text: "Unit Price", value: "price", align: "start", sortable: false },
      { text: "Quanity", value: "quantity", align: "start", sortable: false },
      { text: "Subtotal", value: "subtotal", align: "start", sortable: false },
      { text: "", value: "actions", align: "start", sortable: false }
    ]
  }),
  computed: {
    ...mapGetters([
      "cartItemList",
      "isLoggedIn",
      "currentUser",
      "cartValue"
    ])
  },
  mounted(){
  },
  methods: {
    ...mapActions([
      "addMessage",
      "saveToTransaction",
      "clearCart",
      "removeItemInCart"
    ]),
    removeItem(cartItem) {
      this.removeItemInCart({
        item: cartItem
      });
    },
    checkValidCart(itemList, prodList) {
      let isValid = true;
      let message = "";

      itemList.map(item => {
        for (let prodIdx = 0; prodIdx < prodList.length; prodIdx++) {
          if (prodList[prodIdx].id == item.id) {
            if (prodList[prodIdx].quantity < item.quantity) {
              message = `Only ${prodList[prodIdx].quantity} ${item.title} available in stock`;
              isValid = false;
              return;
            }
            break;
          }
        }
      });
      return {
        isValid,
        message
      };
    },
  }
};
</script>
